import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKeyZ = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M13.6 4C8.862 4 5 7.862 5 12.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6C45 7.862 41.138 4 36.4 4H13.6zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 31.4V12.6C7 8.943 9.943 6 13.6 6zm5.847 8.08v1.78h8.668v.175l-8.974 12.492v1.407h11.722v-1.78h-9.119v-.175l8.932-12.493V14.08H19.447zM7 36.902A8.588 8.588 0 0 0 13.6 40h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6H13.6A6.585 6.585 0 0 1 7 38.4v-1.498z" />
    </svg>
);
export default SvgKeyZ;
